module.exports = __webpack_public_path__ + "img/yeni-vilcatoma.02370192.png";